RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    models.SocialChannel = Backbone.Model.extend({
        urlRoot: '/api/channels',

        getDetails: function () {
            const me = this;
            return CompareData.sourceDetails[me.get('source')];
        },

        getHandle: function (handle) {
            const me = this;

            return new models.SocialHandle({
                id: handle,
                source: me.get('source')
            });
        }
    });
}, RivalIQ.data.CompareData);
